import { createAsyncThunk } from '@reduxjs/toolkit';
import { getConnectwisePriorities } from 'services/connectwise';

export const ThunkGetConnectwisePriorities = createAsyncThunk(
  'connectwise/getConnectwisePriorities',
  (psaId: number) =>
    getConnectwisePriorities(psaId)
      .then(res => res.data)
      .then(data => data.sort((a, b) => a.label.localeCompare(b.label))),
);

export default {};
